/** @format */

export type DocumentDetail = {
  document_ref_id: string;
  base64_data: string;
  content_type: string;
  document_name: string;
};

export type HistoryPushStateType = {
  history: any;
  pathname?: string;
  state?: Record<string, any>;
  replaceState?: Record<string, any>; // แทนที่ state เดิม
  storedState?: Record<string, any> | null;
  reload?: boolean;
  search?: string;
  replace?: boolean;
  replacePath?: string;
  resetPath?: string;
  cutOff?: string;
};

export const INSURANCE_URLS = {
  CLAIM_DETAIL: "/claim-detail",
  CLAIM_LIST: "/claim-list",
  SELECT_PACKAGE: "/select-package",
  INSURANCE_CONSENT: "/insurance-consent",
  INSURANCE_PDF: "/insurance-pdf",
  EXCESS_CLAIM_LIST: "/excess-claim-list",
  EXCESS_CLAIM_DETAIL: "/excess-claim-detail",
  VERIFICATION_LIST: "/verification-list",
  PER_VERIFICATION_CONSENT:"/pre-verification-consent",
  PER_VERIFICATION_DETAIL:"/pre-verification-detail",
  PDF_LIST:"/insurance-pdf-list"
};

export type LocationType = {
  routes?: string[];
};

export type EstimatorType = {
  Result: EstimatorResultType;
  Data: EstimatorDataType;
  package?: PackageType;
  policy?: PolicyStatusType;
};

export type EstimatorResultType = {
  Code?: string;
  Message?: string;
  MessageTh?: string;
};

export type EstimatorDataType = {
  RefId?: string;
  TransactionNo?: string;
  InsurerCode?: string;
  PolicyType?: string;
  PackageCode?: string;
  PresentedPrice?: number;
  OutOfPocket?: number;
  Title?: Record<string, any>;
  Url?: Record<string, any>;
  RemarkList?: any;
  AlternativeList?: any;
};

export type PolicyStatusType = {
  policyInfoList?: any;
  transactionNo?: string;
  identityNumber?: string;
  coverageList?: Record<string, any>;
  coverageClaimStatus?: boolean;
  remarkList?: any;
  contracts?: Record<string, any>;
  customerDetail?: customerDetail;
  refid?: string;
  insuredNotEligibleReasons?: any[];
  identityType?: string;
};

export type customerDetail = {
  lastName?: string;
  firstName?: string;
  policyDescription?: string;
  policyNo?: string;
  nationalId?: string;
  membershipId?: string;
};

export type PackageType = {
  packageCode?: string;
  packageCodeHospital?: string;
  packageName?: string;
  packageNameTH?: string;
};

export type UIPolicy = {
  identityType?: string;
  policyNo?: string;
  policyDescription?: string;
  refid?: string;
};

export type InsuranceListType = {
  insurance_code: string;
  insurance_name_en: string;
  insurance_name_th: string;
  insurance_short_name: string;
  insurance_logo: string;
  is_api: boolean;
  is_broker: boolean;
  is_ims_insurance: boolean;
  insurance_type: string;
  visit_type?: string;
  claim_groups?: any;
  claim_types?: any;
  insured_types?: any;
};

export type InsuranceDataFormatType = {
    doc_id?: string,
    hn?: string,
    en?: string,
    bu_code?: string,
    source?: string,
    status?: string,
    original_payload?: InsuranceDataSubmissionsType;
    submission_datetime?: string,
    last_status_update?: any,
    insurance_statuses?: any[],
    insurance_count?: number,
    // add ondata
    dataSubmissions: InsuranceDataSubmissionsType;
    insuranceSelected?: InsuranceListType;
    expand?: boolean;
    cardSelected?: boolean;
    isActive?: boolean;
    id?:string;
    cardType: cardType
    emptyField?: string[]
};

export type cardType = "submit" | "lastvisit" | "newcard"

export type InsuranceDataSubmissionsType = {
  bu_code: number;
  hospital_name: string;
  is_accident: boolean;
  accident_datetime: string;
  episode_no: string;
  insurance_code: string;
  appointment_date: string;
  visit_date: string;
  hn: string;
  signature_data: string;
  insured_type_name: string;
  claim_group: string;
  claim_type: string;
  symptoms?: string;
  voucher?: string
  insurance_card_copy?: any;
  remark?: string;
  is_broker?: boolean;
};

export type ImageFromNativeType = {
  id: string,
  base64String: string;
  blobPath: string;
};

export type ReservationDetailType = {
  insurance_code: string;
  insurance_name_en: string;
  insurance_name_th: string;
  insurance_name_shot_name: string;
  insurance_logo: string;
  is_api: boolean;
  is_broker: boolean;
  is_ims_insurance: boolean;
  insurance_type: string;
  insured_type_name: string;
  claim_group: string;
  claim_type: string;
  visit_type: string;
  reserve_no: string;
  reserve_status: string;
  reserved_datetime: string;
  policy_detail: PolicyDetail[];
}

export type PolicyDetail = {
  policy_no: string;
  policy_status: boolean;
  reason_policy: string;
  benefit: BenefitItem[];
  verify_letter: string[];
}

export type BenefitItem = {
  sr_policy_id: number;
  coverage_name: string;
  coverage_value: string;
  coverage_unit: string;
  coverage_per: string;
  coverage_remaining_value: string;
  coverage_copay_coinsurance_value: number | null;
  coverage_copay_coinsurance_unit: string | null;
  reason_at_itemized: string;
  remark_at_itemized: string;
}

export type VerifyLetterType = {
  policyNo: string;
  base64: string;
  displayName: string;
}

export type MenuItemStatusType = {
  titleTh: string;
  titleEn: string;
  subTitleTh: string;
  subTitleEn: string;
  menu: string;
  isDisabled: boolean;
}

export type MenuItemStatusSelectedType = {
  title?: string;
  subTitle?: string;
}